import queryString from 'query-string'
import { useLocation } from 'lib/router'
import { useStore } from 'state/store'
import Connections from 'views/Connections'
import Loading from 'components/Loading'

const ConnectionsContainer = () => {
  const workspaceId = useStore(state => state.workspace.id)
  const organizationId = useStore(state => state.organization.id)
  const location = useLocation()
  const { connectionId: id } = queryString.parse(location.search)
  const connectionId = (id as string) || ''

  if (!workspaceId || !organizationId) {
    return <Loading />
  }

  return (
    <Connections
      organizationId={organizationId}
      workspaceId={workspaceId}
      connectionId={connectionId}
    />
  )
}

export default ConnectionsContainer
